<!-- ============================================
        ANGULAR COMPONENT TEMPLATE
        ============================================ -->

<div class="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50/30 to-slate-100 p-6">
  <div class="max-w-screen-2xl mx-auto space-y-3">
    <!-- ============================================
            HEADER SECTION
            ============================================ -->
    <div class="bg-white rounded-xl border border-slate-200/60 shadow-lg shadow-slate-200/50 px-6 py-4">
      <div class="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
        <!-- Title Area data-kt-drawer-toggle="#drawers_shop_cart" -->
        <!-- <div>
          <h2 class="text-lg font-bold text-slate-800 tracking-tight">
            Invoice Management
          </h2>
          <p class="text-xs text-slate-500 uppercase tracking-wider font-medium mt-0.5">
            Enterprise Resource Planning
          </p>
        </div> -->
        <button class="kt-btn kt-btn-primary" (click)="addRecord()">
          <i class="ki-filled ki-handcart"> </i>
          Add
        </button>

        <!-- Actions & Search -->
        <div class="flex flex-wrap items-center gap-3">
          <!-- Search Input -->
          <div class="relative group">
            <input type="text" (input)="onSearchInput($any($event.target).value)" placeholder="Search invoices..."
              class="w-72 pl-10 pr-4 py-2.5 text-sm bg-slate-50 border border-slate-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 focus:bg-white outline-none transition-all duration-200 placeholder:text-slate-400" />

            <svg
              class="w-4 h-4 text-slate-400 absolute left-3 top-1/2 -translate-y-1/2 group-focus-within:text-blue-500 transition-colors"
              fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"></path>
            </svg>
          </div>

          <!-- Advanced Filter Toggle -->
          <button
            class="px-4 py-2.5 text-sm font-semibold text-blue-600 hover:text-blue-700 hover:bg-blue-50 rounded-lg transition-all duration-200 flex items-center gap-2"
            (click)="showAdvancedFilter = !showAdvancedFilter">
            <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M3 4a1 1 0 011-1h16a1 1 0 011 1v2.586a1 1 0 01-.293.707l-6.414 6.414a1 1 0 00-.293.707V17l-4 4v-6.586a1 1 0 00-.293-.707L3.293 7.293A1 1 0 013 6.586V4z">
              </path>
            </svg>
            {{ showAdvancedFilter ? 'Hide Filters' : 'Advanced Filters' }}
          </button>
        </div>
      </div>
    </div>

    <div *ngIf="selectedRow" class="border border-blue-100 rounded-lg bg-blue-50/50 px-3 py-2 text-xs shadow-sm">

      <!-- BOTTOM BAR -->
      <div class="flex items-center gap-2 mt-2">

        <!-- SELECTED INFO -->
        <div class="flex items-center gap-2">
          <!-- TEXT -->
          <div class="leading-tight">
            <p class="text-[11px] text-blue-600 font-medium">
                Selected Entiy : {{ entity | titlecase }}
            </p>

            <p class="text-[11px] font-semibold text-blue-900">
              Org: {{ selectedRow?.org_id || selectedRow?.orgId || 'N/A' }}
            </p>
          </div>
        </div>

      
    <button class="px-2.5 py-1 text-[11px] font-medium 
            text-sky-800 bg-sky-100 
            border border-sky-300 
            rounded-md 
            hover:bg-sky-200 hover:border-sky-400 
            transition-all duration-150 
            flex items-center gap-1">

      View
    </button>
        <!-- SPACE -->
        <div class="flex-1"></div>

        <!-- SMALL DELETE BUTTON -->
        <button
          class="px-2.5 py-1 text-[11px] font-medium text-white bg-red-600 hover:bg-red-700 rounded-md flex items-center gap-1">

        

          Delete
        </button>

      </div>

    </div>

    <!-- Advance Filter  -->
    <div *ngIf="showAdvancedFilter"
      class="bg-white rounded-xl border border-slate-200 shadow-2xl px-6 py-6 animate-slide-down mb-6">
      <div class="flex items-center justify-between mb-6">
        <div class="flex items-center gap-2">
          <div class="p-2 bg-blue-50 rounded-lg">
            <svg class="w-5 h-5 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M3 4a1 1 0 011-1h16a1 1 0 011 1v2.586a1 1 0 01-.293.707l-6.414 6.414a1 1 0 00-.293.707V17l-4 4v-6.586a1 1 0 00-.293-.707L3.293 7.293A1 1 0 013 6.586V4z">
              </path>
            </svg>
          </div>
          <div>
            <h3 class="text-sm font-bold text-slate-800">Filter Invoices</h3>
            <p class="text-[10px] text-slate-500 uppercase tracking-widest font-semibold">
              Refine your document list
            </p>
          </div>
        </div>
      </div>

      <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        <ng-container *ngFor="let f of filterFields">
          <div class="flex flex-col gap-1.5">
            <label class="text-[11px] font-bold text-slate-500 uppercase ml-1">
              {{ f.label }}
            </label>

            <div class="relative group">
              <div
                class="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400 group-focus-within:text-blue-500 transition-colors duration-200">
                <svg *ngIf="f.filterType === 'autocomplete'" class="w-4 h-4" fill="none" stroke="currentColor"
                  viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"></path>
                </svg>
                <svg *ngIf="f.filterType === 'text'" class="w-4 h-4" fill="none" stroke="currentColor"
                  viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z">
                  </path>
                </svg>
                <svg *ngIf="f.filterType === 'number'" class="w-4 h-4" fill="none" stroke="currentColor"
                  viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M7 20l4-16m2 16l4-16M6 9h14M4 15h14"></path>
                </svg>
                <svg *ngIf="f.filterType === 'date'" class="w-4 h-4" fill="none" stroke="currentColor"
                  viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"></path>
                </svg>
              </div>

              <ng-container *ngIf="f.filterType === 'autocomplete'">
                <input type="text" [placeholder]="'Search ' + f.label" [formControl]="docSearchControl"
                  [matAutocomplete]="autoDoc"
                  class="w-full pl-9 pr-3 py-2.5 text-sm bg-slate-50 border border-slate-200 rounded-lg focus:ring-2 focus:ring-blue-500 focus:bg-white focus:border-blue-500 outline-none transition-all duration-200 placeholder:text-slate-400" />

                <mat-autocomplete #autoDoc="matAutocomplete" (optionSelected)="
                    advancedFilters.documentno = $event.option.value
                  ">
                  <mat-option *ngFor="let doc of documentSuggestions" [value]="doc" class="professional-option">
                    <div class="flex items-center gap-2">
                      <span class="w-2 h-2 rounded-full bg-blue-400"></span>
                      <span class="text-sm font-medium text-slate-700">{{
                        doc
                        }}</span>
                    </div>
                  </mat-option>
                </mat-autocomplete>
              </ng-container>

              <ng-container *ngIf="f.filterType === 'text'">
                <input type="text" [placeholder]="'Enter ' + f.label" [(ngModel)]="advancedFilters[f.field]"
                  class="w-full pl-9 pr-3 py-2.5 text-sm bg-slate-50 border border-slate-200 rounded-lg focus:ring-2 focus:ring-blue-500 focus:bg-white focus:border-blue-500 outline-none transition-all duration-200 placeholder:text-slate-400" />
              </ng-container>

              <ng-container *ngIf="f.filterType === 'number'">
                <input type="number" [placeholder]="'0.00'" [(ngModel)]="advancedFilters[f.field]"
                  class="w-full pl-9 pr-3 py-2.5 text-sm bg-slate-50 border border-slate-200 rounded-lg focus:ring-2 focus:ring-blue-500 focus:bg-white focus:border-blue-500 outline-none transition-all duration-200 placeholder:text-slate-400" />
              </ng-container>

              <ng-container *ngIf="f.filterType === 'date'">
                <input type="date" [(ngModel)]="advancedFilters[f.field]"
                  class="w-full pl-9 pr-3 py-2.5 text-sm bg-slate-50 border border-slate-200 rounded-lg focus:ring-2 focus:ring-blue-500 focus:bg-white focus:border-blue-500 outline-none transition-all duration-200 text-slate-600" />
              </ng-container>
            </div>
          </div>
        </ng-container>
      </div>

      <div class="flex items-center justify-between mt-6 pt-4 border-t border-slate-100">
        <div class="flex items-center gap-3">
          <button
            class="px-6 py-2.5 text-sm font-bold text-white bg-slate-900 hover:bg-blue-600 rounded-lg transition-all duration-300 shadow-md hover:shadow-blue-200 flex items-center gap-2"
            (click)="applyAdvancedFilters()">
            <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"></path>
            </svg>
            Apply Search
          </button>

          <button
            class="px-4 py-2.5 text-sm font-semibold text-slate-500 hover:text-red-600 hover:bg-red-50 rounded-lg transition-all duration-200"
            (click)="
              docSearchControl.setValue('');
              advancedFilters = {};
              applyAdvancedFilters()
            ">
            Clear All
          </button>
        </div>

        <div class="text-right">
          <p class="text-[10px] font-bold text-slate-400 uppercase tracking-tight">
            Current View
          </p>
          <p class="text-sm font-bold text-slate-700">
            {{ total || 0 }}
            <span class="text-slate-400 font-medium">Results found</span>
          </p>
        </div>
      </div>
    </div>

    <div class="kt-card kt-card-grid min-w-full border border-slate-200 rounded-xl shadow-sm overflow-hidden mx-auto">

      <div class="kt-card-header py-3 px-4 border-b border-slate-200 bg-white">

        <div data-slot="card-heading" class="space-y-1">
          <div class="flex items-center gap-2.5">
              <div class="flex">
                <label class="kt-input">
                  <i class="ki-filled ki-magnifier">
                  </i>
                  <input data-kt-datatable-search="#team_crew_table" placeholder="Search users" type="text" value="">
                </label>
              </div>
          </div>
        </div>
        
        <div *ngIf="selectedRow" data-slot="card-toolbar" class="flex items-center gap-2.5">
          <!-- <div class="flex flex-wrap items-center gap-2.5"> -->

            <swerp-workflow-action-bar [metaEntity]="metaEntity" [module]="moduleCode" [entity]="entity" [recordId]="selectedRow?.id"
            (actionClick)="onAction($event)">
            </swerp-workflow-action-bar>
            
            <!-- <button class="kt-btn kt-btn-outline kt-btn-primary">
              <i class="ki-filled ki-setting-4">
              </i>
              Edit
            </button>

            <button class="kt-btn kt-btn-outline kt-btn-primary">
                  <i class="ki-filled ki-setting-4">
                  </i>
                  View
            </button>

            <button class="kt-btn kt-btn-outline kt-btn-primary">
                  <i class="ki-filled ki-setting-4">
                  </i>
                  Delete
            </button> -->

              <!-- <swerp-entity-workflow-panel [entity]="entity" [recordId]="selectedRow?.id">
              </swerp-entity-workflow-panel> -->

          <!-- </div> -->
        </div>
        
      </div>

      

      <!-- <div class="kt-card-header py-3 px-4 border-b border-slate-200 bg-white">

        <h5 class="kt-card-title text-sm font-medium text-black-600">

        </h5>
        <div class="flex flex-wrap gap-2 lg:gap-5">
          <div class="flex">
           <label class="kt-input">
            <i class="ki-filled ki-magnifier">
            </i>
            <input data-kt-datatable-search="#team_crew_table" placeholder="Search users" type="text" value="">
           </label>
          </div>
          <div *ngIf="selectedRow" class="flex flex-wrap gap-2.5">
           
<button class="kt-btn kt-btn-outline kt-btn-primary">
            <i class="ki-filled ki-setting-4">
            </i>
            Edit
      </button>

      <button class="kt-btn kt-btn-outline kt-btn-primary">
            <i class="ki-filled ki-setting-4">
            </i>
            View
      </button>

      <button class="kt-btn kt-btn-outline kt-btn-primary">
            <i class="ki-filled ki-setting-4">
            </i>
            Delete
      </button>

            <swerp-entity-workflow-panel [entity]="entity" [recordId]="selectedRow?.id">
            </swerp-entity-workflow-panel>

          </div>
         </div>

      </div> -->

      <div class="kt-card-content overflow-x-auto">
        <table class="kt-table table-auto w-full border-separate border-spacing-0" data-kt-datatable-table="true">
          <thead class="bg-slate-50">
            <tr>
              <th *ngFor="let col of columnsConfig; let last = last" (click)="col.isSortable && onSort(col.field)"
                class="py-2.5 px-4 text-[11px] uppercase text-black-500 font-bold tracking-wider select-none cursor-pointer hover:bg-slate-100 border-b border-slate-200 transition-colors"
                [class.border-r]="!last">
                <div class="flex items-center justify-between gap-1">
                  <span class="kt-table-col-label">{{ col.label }}</span>

                  <div class="flex items-center">
                    <span *ngIf="sortField === col.field" class="text-blue-600">
                      <svg *ngIf="sortDir === 'asc'" class="w-3 h-3" viewBox="0 0 20 20" fill="currentColor">
                        <path d="M5 10l5-5 5 5H5z"></path>
                      </svg>
                      <svg *ngIf="sortDir === 'desc'" class="w-3 h-3" viewBox="0 0 20 20" fill="currentColor">
                        <path d="M15 10l-5 5-5-5h10z"></path>
                      </svg>
                    </span>
                    <svg *ngIf="sortField !== col.field && col.isSortable" class="w-3 h-3 text-slate-300" fill="none"
                      stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                        d="M7 16V4m0 0L3 8m4-4l4 4m6 0v12m0 0l4-4m-4 4l-4-4"></path>
                    </svg>
                  </div>
                </div>
              </th>
            </tr>
          </thead>

          <tbody class="bg-white">
            <tr *ngFor="let row of dataSource" (click)="selectRow(row)" (dblclick)="editRow(row)"
              [class.bg-blue-50/50]="selectedRow === row"
              class="group hover:bg-slate-50/80 transition-colors cursor-pointer">
              <td *ngFor="let col of columnsConfig; let last = last"
                class="py-2 px-4 text-sm text-black-600 border-b border-slate-100" [class.border-r]="!last">
                <div class="flex items-center truncate min-h-[24px] font-normal text-foreground">
                  <span [innerHTML]="highlight(row[col.field])"></span>
                </div>
              </td>
            </tr>

            <tr *ngIf="dataSource.length === 0">
              <td [attr.colspan]="columnsConfig.length"
                class="text-center py-12 text-slate-400 text-sm italic bg-slate-50/30">
                No records found
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div
        class="kt-card-footer flex flex-wrap items-center justify-between gap-4 px-4 py-2.5 bg-white border-t border-slate-200 text-xs font-medium">
        <div class="flex items-center gap-3 text-sm text-black-600">
          <!-- <h3 class="kt-card-title text-sm font-medium text-black-600">
            Showing {{ pageIndex * pageSize + 1 }}-{{
            (pageIndex + 1) * pageSize > total
            ? total
            : (pageIndex + 1) * pageSize
            }}
            of {{ total }}
          </h3>
          | -->
          <span>Show</span>
          <select [value]="pageSize" (change)="changePageSize($event)"
            class="kt-select w-20 border-2 border-slate-200 rounded-lg px-3 py-2 bg-white text-slate-800 outline-none focus:border-blue-500 transition-all cursor-pointer shadow-sm text-sm">
            <option [value]="5">5</option>
            <option [value]="10">10</option>
            <option [value]="25">25</option>
            <option [value]="50">50</option>
          </select>
          <span>per page</span>
        </div>
        <div class="flex items-center gap-6 text-black-600 font-medium">
          <span class="hidden sm:inline-block text-sm">
            {{ pageIndex * pageSize + 1 }}-{{
            (pageIndex + 1) * pageSize > total
            ? total
            : (pageIndex + 1) * pageSize
            }}
            of {{ total }}
          </span>

          <div class="flex items-center gap-2">
            <button (click)="goToPage(pageIndex - 1)" [disabled]="pageIndex === 0"
              class="w-9 h-9 flex items-center justify-center rounded border border-slate-300 bg-white hover:bg-slate-100 disabled:opacity-30 disabled:hover:bg-transparent transition-colors shadow-sm text-slate-600">
              <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7"></path>
              </svg>
            </button>

            <div
              class="w-9 h-9 flex items-center justify-center bg-slate-100 border border-slate-200 rounded text-slate-900 font-bold text-sm shadow-inner">
              {{ pageIndex + 1 }}
            </div>

            <button (click)="goToPage(pageIndex + 1)" [disabled]="pageIndex >= totalPages - 1"
              class="w-9 h-9 flex items-center justify-center rounded border border-slate-300 bg-white hover:bg-slate-100 disabled:opacity-30 disabled:hover:bg-transparent transition-colors shadow-sm text-slate-600">
              <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"></path>
              </svg>
            </button>
          </div>
        </div>
      </div>
    </div>
    <div
      class="hidden kt-drawer kt-drawer-end card flex-col max-w-[90%] top-5 bottom-5 end-5 rounded-xl border border-border"
      data-kt-drawer="true" data-kt-drawer-container="body" id="drawers_shop_cart">
      <!-- <ng-container *ngIf="shwoDynamicForm">
        <app-dynamic-form-page [entity]="entity" [recId]="recId" (saved)="onFormSaved()">
        </app-dynamic-form-page>
      </ng-container> -->

      <ng-container *ngIf="metaEntity.placement === 'drawer'">
        <app-render-form-page [entity]="entity" [recId]="recId" (saved)="onFormSaved()"> 
        </app-render-form-page>
      </ng-container>
  
  </div>
</div>